import type { DashboardLayout } from './types';

const CSRF_COOKIE = 'pacebi_csrf';

function csrfToken(): string {
  const m = document.cookie.match(new RegExp('(?:^|; )' + CSRF_COOKIE + '=([^;]+)'));
  return m ? decodeURIComponent(m[1]) : '';
}

// fetchDashboard returns the caller's saved layout, or a default (empty
// widgets) when none is saved — the page substitutes the Resumen default then.
export async function fetchDashboard(): Promise<DashboardLayout> {
  const res = await fetch('/api/dashboard', { credentials: 'same-origin' });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return (await res.json()) as DashboardLayout;
}

// saveDashboard replaces the caller's layout (used by the edit mode, phase 3).
export async function saveDashboard(layout: DashboardLayout): Promise<DashboardLayout> {
  const res = await fetch('/api/dashboard', {
    method: 'PUT',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken() },
    body: JSON.stringify(layout),
  });
  if (!res.ok) throw new Error(await res.text());
  return (await res.json()) as DashboardLayout;
}

// resetDashboard drops the caller's saved layout — the SPA falls back to the
// Resumen default, same as a user who never saved one (phase 3 "Restablecer").
export async function resetDashboard(): Promise<void> {
  const res = await fetch('/api/dashboard', {
    method: 'DELETE',
    credentials: 'same-origin',
    headers: { 'X-CSRF-Token': csrfToken() },
  });
  if (!res.ok) throw new Error(await res.text());
}
